export default __webpack_public_path__ + "static/media/2.8156e6f1.webp";